<template>
  <div class="addContent">
    <el-form-item :label="name+'_'+item.num" class="flexEnd" v-for="(item,index) in dataList">
      <div class="flexEnd">
        <quill ref="quill" :uploadUrl="uploadUrl" :quillId="'quillID_'+name+item.num" :height="100"></quill>
        <!--<el-input type="textarea" :rows="3" v-model="item.contentTxt" maxlength="200" show-word-limit></el-input>-->
        <div class="div_btn">
          <el-button type="primary" size="mini" @click="submit(index,item.num)" class="definite">{{$t('im.bt.definite')}}</el-button>
          <el-button size="mini" @click="addList(index)">{{$t('im.bt.addOne')}}</el-button>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
  import apiDeployManagement from '@/api/im/deployManagement'
  import quill from '@/views/IM/model/quill.vue'
  import Util from '@/utils/IM/tradeDataUtil'

  export default {
    name: 'addContent',
    props: ['list', 'num', 'name', 'businessGroupCode', 'userType', 'langId', 'userInfo'],
    components: {
      quill
    },
    computed: {
      data: {
        get() {
          for (const i in this.list){
            this.$nextTick(() => {
              this.$refs.quill[i].init("")
            })
          }
          return this.list
        }
      },
      number: {
        get() {
          return this.num
        }
      },
    },
    data() {
      return {
        index: JSON.parse(JSON.stringify(this.num)),
        dataList: this.list,
        uploadUrl: process.env.VUE_APP_BASE_API + '/serviceBusiness/api/upload/uploadMulti',
      }
    },
    methods: {
      addList(index) {
        if (this.number >= 3 || this.index >= 3 || this.dataList.length > 2) {
          this.$message(window.$t('im.common.notExceed'))
          return
        }
        this.index++
        this.dataList.push({
          contentTxt: '',
          num: this.index
        })
        for (const i in this.dataList){
          this.$nextTick(() => {
            this.$refs.quill[i].init("")
          })
        }
      },
      addWelcomeMessage(val, clientType, num) {
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          bizCode: this.businessGroupCode,
          companyId: this.userInfo.companyId,
          locale: this.langId,
          clientType: clientType,
          userType: this.userType,
          message: val,
          sort: num
        }
        apiDeployManagement.addConWelcomeMessage(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.addSuc'))
            this.$emit('change')
          } else {
            this.$message.error(window.$t('im.common.addFail'))
          }
        })
      },
      submit(index, num) {
        if (Util.isNotEmpty(this.$refs.quill[index].getHtml().replace(/\s/g, ''))) {
          let clientType
          if (this.name == 'PC') {
            clientType = 1
          } else if (this.name == 'M') {
            clientType = 0
          } else if (this.name == 'APP') clientType = 2
          if (this.data[0].len < 3) {
            this.addWelcomeMessage(this.$refs.quill[index].getHtml(), clientType, num)
          } else {
            this.$message(window.$t('im.common.notExceed'))
          }
        } else {
          this.$message.error(window.$t('im.common.notNull'))
        }
      }
    },
    mounted(){
    },
    watch: {
      data: {
        deep: true,
        handler(newVal, oldVal) {
          if (newVal && newVal.length == 1) {
            this.index = JSON.parse(JSON.stringify(this.number))
            this.dataList = JSON.parse(JSON.stringify(newVal))
          }
        }
      }
    }
  }
</script>
<style>
  .addContent .definite.el-button--mini span{
    letter-spacing: 8px;
    padding-left: 8px;
  }
</style>
